// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow","isDisable":"is-disable"};